import type { RouteObject } from "react-router";

import { FullScreenLoader } from "@/app/session/RequireSession";
import { PortalNotFound, PortalRouteError } from "@/portal/routes/PortalRouteError";

/* The client portal: its own route tree, shell and session, loaded only when someone opens
   /portal. Mounted from app/router.tsx as one entry. */
export const portalRoute: RouteObject = {
  path: "/portal",
  errorElement: <PortalRouteError />,
  hydrateFallbackElement: <FullScreenLoader />,
  lazy: async () => ({ Component: (await import("@/portal/PortalRoot")).default }),
  children: [
    {
      path: "sign-in",
      lazy: async () => ({
        Component: (await import("@/portal/routes/PortalSignInPage")).default,
      }),
    },
    {
      path: "forgot-password",
      lazy: async () => ({
        Component: (await import("@/portal/routes/PortalForgotPasswordPage")).default,
      }),
    },
    {
      path: "forgot-password/code",
      lazy: async () => ({
        Component: (await import("@/portal/routes/PortalResetCodePage")).default,
      }),
    },
    {
      path: "forgot-password/new",
      lazy: async () => ({
        Component: (await import("@/portal/routes/PortalNewPasswordPage")).default,
      }),
    },
    {
      path: "invitation/:token",
      lazy: async () => ({
        Component: (await import("@/portal/routes/PortalInvitationPage")).default,
      }),
    },
    {
      lazy: async () => ({
        Component: (await import("@/portal/session/RequirePortalSession")).RequirePortalSession,
      }),
      children: [
        {
          lazy: async () => ({
            Component: (await import("@/portal/shell/PortalShell")).PortalShell,
          }),
          children: [
            {
              index: true,
              lazy: async () => ({
                Component: (await import("@/portal/routes/PortalHomePage")).default,
              }),
            },
            {
              path: "tickets",
              lazy: async () => ({
                Component: (await import("@/portal/routes/PortalTicketsPage")).default,
              }),
            },
            {
              path: "tickets/new",
              lazy: async () => ({
                Component: (await import("@/portal/routes/PortalNewTicketPage")).default,
              }),
            },
            {
              path: "tickets/:ticketId",
              lazy: async () => ({
                Component: (await import("@/portal/routes/PortalTicketPage")).default,
              }),
            },
            {
              path: "projects/:key",
              lazy: async () => ({
                Component: (await import("@/portal/routes/PortalProjectPage")).default,
              }),
            },
            {
              path: "approvals/:id",
              lazy: async () => ({
                Component: (await import("@/portal/routes/PortalApprovalPage")).default,
              }),
            },
            { path: "*", Component: PortalNotFound },
          ],
        },
      ],
    },
  ],
};
